import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IStoreSlice, TldPrice } from "@/redux/slices/store/types";

export const getTldPrices = createAsyncThunk(
  "store/getTldPrices",
  async ({
           filter = "",
           ids = [],
           period,
           category = "all",
           action = "create",
         }: {
    filter?: string;
    ids?: number[];
    period?: number;
    category?: "popular" | "personal" | "business" | "geographic" | "all";
    action?: "create" | "renew" | "transfer";
  }) =>
    await axios({
      method: "POST",
      url: `/api/domain-names`,
      data: {
        filter,
        ids,
        period,
        category,
        action,
      },
    }).then((res) => res.data.result)
);

const pending = (state: IStoreSlice) => {
  state.tlds.prices = {
    ...state.tlds.prices,
    loaded: false,
    prices: state.tlds.prices.prices,
  };
};

const fulfilled = (
  state: IStoreSlice,
  { payload }: { payload: TldPrice[] },
) => {
  state.tlds.prices = {
    ...state.tlds.prices,
    loaded: true,
    prices: payload,
  };
};

const failed = (state: IStoreSlice) => {
  state.tlds.prices = {
    ...state.tlds.prices,
    loaded: false,
    prices: state.tlds.prices.prices,
  };
};

export default {
  action: getTldPrices,
  pending,
  fulfilled,
  failed,
};
